'use es6';

import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
const ENDPOINT = 'monetization/v3/purchase-motions';
const PUBLIC_ENDPOINT = 'monetization/v3/purchase-motions/public-pricing';
export const getPurchaseMotionsByLocation = locations => {
  const earlyRequest = getEarlyRequesterResult('purchase-motions');

  const standardGet = () => http.get(ENDPOINT, {
    query: {
      location: locations
    }
  });

  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => standardGet()) : null;
  return earlyRequestWithRetry || standardGet();
};
export const getPublicPurchaseMotionsByLocation = (locations, browserLocale = 'en-us') => {
  const earlyRequest = getEarlyRequesterResult('purchase-motions');
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}/${browserLocale}`;

  const standardGet = () => noAuthHttp.get(url, {
    query: {
      location: locations
    }
  });

  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => standardGet()) : null;
  return earlyRequestWithRetry || standardGet();
};